<template>
  <v-app class="notfound">
    <v-container
      fluid
      fill-height
      class="d-flex flex-column align-center justify-center text-center"
    >
      <transition name="fade-scale">
        <div class="content-wrapper">
          <v-icon size="100" color="#F86031" class="icon-bounce mb-6">
            mdi-alert-circle-outline
          </v-icon>

          <h1 class="error-code">404</h1>
          <h2 class="error-title">Page Not Found</h2>

          <p class="error-message">Oops! The page you’re looking for doesn’t exist or was moved.</p>

          <v-btn
            color="#F86031"
            dark
            class="mt-8 rounded-pill px-8 py-3 text-none btn-animate"
            @click="$router.push('/')"
          >
            Go Home
          </v-btn>

          <div class="dots mt-10"><span></span><span></span><span></span></div>
        </div>
      </transition>
    </v-container>
  </v-app>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;700;900&display=swap');

.notfound {
  font-family: 'Nunito Sans', sans-serif;
  background-color: #ffffff;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.content-wrapper {
  animation: fadeIn 0.9s ease-in-out;
}

.error-code {
  font-size: 100px;
  font-weight: 900;
  color: #f86031;
  line-height: 1;
  margin-bottom: 10px;
  animation: popIn 1s ease;
}

.error-title {
  font-size: 28px;
  font-weight: 900;
  color: #000;
  margin-bottom: 10px;
  animation: fadeInText 1.2s ease-in-out;
}

.error-message {
  font-size: 16px;
  color: #666;
  max-width: 400px;
  margin: 0 auto;
  line-height: 1.6;
  animation: fadeInText 1.5s ease-in-out;
}

.icon-bounce {
  animation: bounceIcon 2s infinite;
}

.btn-animate {
  transition: all 0.3s ease;
}

.btn-animate:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 18px rgba(248, 96, 49, 0.3);
}

.dots {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.dots span {
  width: 10px;
  height: 10px;
  background-color: #f86031;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out both;
}

.dots span:nth-child(1) {
  animation-delay: -0.32s;
}
.dots span:nth-child(2) {
  animation-delay: -0.16s;
}

/* Animations */
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(15px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInText {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes popIn {
  0% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

@keyframes bounceIcon {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

.fade-scale-enter-active {
  transition: all 0.6s ease;
}
.fade-scale-enter {
  opacity: 0;
  transform: scale(0.9);
}
</style>
